export default __webpack_public_path__ + "app/images/d46937ad90849ddefb8d5ede7a71a678.png";